import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../State';
import { EntityRoleActionTypes } from '../State/actions/entity-role.actions';
import { getEntityRoleFetched } from '../State/selectors/entity-role.selector';
import { BaseEntityResolver } from './resolver.helper';

@Injectable({
    providedIn: 'root',
})
export class EntityRoleResolver extends BaseEntityResolver {
    constructor(store: Store<State>) {
        super(getEntityRoleFetched, EntityRoleActionTypes.LoadAll(), store);
    }
}
